import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtMO: CultureInfo = {
  name: 'pt-MO',
  displayName: 'português (Macau)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-MO',
  parent: CultureInfoPt
};
